// removed by extract-text-webpack-plugin
module.exports = {"PokeLandingPage":"PokeLandingPage__PokeLandingPage___36lAe","navContainer":"PokeLandingPage__navContainer___EJsbd","contentContainer":"PokeLandingPage__contentContainer___2Qay8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LandingPages/PokeLandingPage/PokeLandingPage.css
// module id = 209
// module chunks = 0